<script>
  import ProductListItem from '@/components/ProductListItem.vue';
  import { Carousel, Slide, Navigation } from 'vue3-carousel';
  import { whenFastSimonReady, ReportRecommendationView, handleViewportSize } from '@/lib/vue-helpers.js';
  export default {
    name: 'CartWidget',
    components: {
      ProductListItem,
      Carousel,
      Navigation,
      Slide
    },
    mounted() {
      this.handleViewportSize = handleViewportSize(this);
      this.recommendedPids = [];
      this.productImageName = this.$el.parentElement.getAttribute('data-product_swatch_name');
      this.cartRecItemsMobile = this.$el.parentElement.getAttribute('data-cart_recommendation_items_mobile');
      this.widgetId = this.$el.parentElement.getAttribute('data-cart-widget-id');
      this.cartRecItemsMobileFloat = parseFloat(this.cartRecItemsMobile);
      this.cartRecItemsDesktop = this.$el.parentElement.getAttribute('data-cart_recommendation_items_desktop');
      this.cartRecItemsDesktopFloat = parseFloat(this.cartRecItemsDesktop);
      this.showCrosssellPercentage = this.$el.parentElement.getAttribute('data-show-crosssell-percentage') || 'false';
      const useFsProductDataAttr = this.$el.parentElement.getAttribute('data-use-fs-product-data') || this.$el.parentElement.getAttribute('data-use_fs_product_data');
      this.useFsProductData = useFsProductDataAttr === 'false' ? '' : 'true';
      window.addEventListener('start-cart-recommendations', () => {
        this.setCartPids();
      });
      document.addEventListener('theme:resize:width', this.getClientWidth);
    },
    beforeUnmount() {
      if (this.handleViewportSize) this.handleViewportSize();
      document.removeEventListener('theme:resize:width', this.getClientWidth);
    },
    data() {
      return {
        itemsToShow: 5,
        productImageName: '',
        productsOnDisplay: [],
        maxProducts: 9,
        recommendedPids: [],
        maxRetry: 10,
        currentRetry: 0,
        widgetId: '',
        showCrosssellPercentage: 'false',
        useFsProductData: ''
      };
    },
    methods: {
      setClickTrack() {
        window.setFindingMethod('Cart Recommendations');
      },
      reportProductViewRecommendation(productID, index, widgetId) {
        this.setClickTrack();
        whenFastSimonReady(() => {
          window.FastSimonSDK.event({
            eventName: window.FastSimonEventName.RecommendationProductClicked,
            data: {
              productID: productID,
              position: index,
              widget_id: widgetId || ''
            }
          });
        });
      },
      setCartPids() {
        if (document.querySelectorAll('[data-cart-item]').length > 0) {
          [...document.querySelectorAll('.drawer__content .cart__items__row')].forEach(item => {
            this.recommendedPids.push(item.getAttribute('data-cart-item'));
          });
          this.getClientWidth();
          this.getProductRecs();
        } else {
          if (this.currentRetry < this.maxRetry) {
            this.currentRetry = this.currentRetry + 1;
            setTimeout(() => {
              this.setCartPids();
            }, 250);
          }
        }
      },
      getProductRecs() {
        whenFastSimonReady(() => {
          window.FastSimonSDK.productRecommendationByWidget({
            withAttributes: true,
            widgetsIDS: [this.widgetId],
            callback: response => {
              const prods = response.payload[0].payload;
              const dataModified = [];
              if (prods.length > 0) {
                prods.forEach(item => {
                  if (dataModified.length < this.maxProducts) {
                    dataModified.push(item);
                  }
                });
              }
              ReportRecommendationView(dataModified, this.widgetId);
              this.productsOnDisplay = dataModified;
              document.getElementById('cart-recommendations-wrapper').style.display = 'block';
            }
          });
        });
      },
      getClientWidth() {
        const width = document.documentElement.clientWidth;
        if (width <= window.theme.sizes.medium) {
          this.itemsToShow = this.cartRecItemsMobileFloat;
        } else {
          this.itemsToShow = this.cartRecItemsDesktopFloat;
        }
      }
    }
  };
</script>

<template>
  <carousel :items-to-show="itemsToShow" :items-to-scroll="1" :mouse-drag="false" class="recommendation-carousel" snapAlign="start" v-if="productsOnDisplay.length">
    <template #addons>
      <Navigation />
    </template>
    <slide v-for="(product, index) in productsOnDisplay" :key="product + '-' + index + product.id" :pid="product.id">
      <ProductListItem :fsData="product" :useFsProductData="useFsProductData" :productTitle="product.l" :pid="product.id" :productImageName="productImageName" @click="reportProductViewRecommendation(product.id, index, widgetId || '')" :key="'grid' + product + '-' + index" v-if="product.l" :hideSwatches="true" :hideQuickview="true" :disableSlider="true" :showSalePercentage="showCrosssellPercentage === 'true'"> </ProductListItem>
    </slide>
  </carousel>
</template>

<style lang="scss">
  #cart-recommendations-wrapper {
    display: none;
  }

  #cart-recommendation-loader .loader {
    background-color: #ccc;
    width: 100%;
    min-height: 100px;
    border-bottom: 2px solid #fff;
    border-top: 2px solid #fff;
    animation: loading 1.5s ease infinite;
  }

  .cart__drawer .drawer__body {
    .is-mobile & {
      scrollbar-color: #ffffff00 #ffffff00;
    }
  }

  #cart-recommendations {
    .carousel__slide {
      scroll-snap-stop: always;
      align-items: baseline;
      flex-shrink: 0;
    }

    .carousel__viewport {
      &.product-image-carousel {
        overflow: hidden;
      }
    }

    .carousel__track {
      margin-left: 0;
      margin-bottom: 1rem;
      display: flex;
      position: relative;
      width: unset !important;
      padding: 0 0 0 16px !important;
    }

    &.is-tablet,
    &.is-desktop {
      .carousel {
        overflow: hidden;
        touch-action: auto;
      }

      .carousel__viewport {
        overflow: scroll;
      }

      .carousel__track {
        padding: 0 0 0 20px !important;
        transform: none !important;
      }
    }

    .product-grid-item {
      padding-right: 15px;
    }

    .product-grid-item {
      padding-right: 1rem;
    }

    .product-grid-item__container {
      z-index: 1;
    }

    .topLeftBadge {
      display: none;
    }

    .product-grid-single-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .product-grid-item__image {
      display: block;
      transform: translateZ(0);
      -webkit-transform: translateZ(0);
      width: 100%;
    }

    .product__grid__info {
      padding-top: 0;

      .product__grid__title {
        margin-top: 2px;
      }
    }

    [data-grid-link] {
      padding-top: 10px;
    }

    .product__grid__vendor + [data-grid-link] {
      padding-top: 0;
    }

    .product__grid__title__wrapper {
      padding-left: 0;
    }

    .product__grid__price {
      padding-left: 0;
    }

    .carousel__prev,
    .carousel__next {
      opacity: 0;
    }
  }
</style>
